import { type ApplicationEditions, PREMIUM_EDITION } from '@atlassian/jira-shared-types';

export const isPremium = (appEditions?: ApplicationEditions): boolean =>
	appEditions !== undefined &&
	(appEditions.software === PREMIUM_EDITION ||
		appEditions.core === PREMIUM_EDITION ||
		appEditions.serviceDesk === PREMIUM_EDITION);
